import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PromotionPacket from './PromotionPacket';
import { PromotionPacketProvider } from './PromotionPacketContext';

const PromotionPacketPage: FC = () => {
  const params = useParams<{ id: string }>();
  const promotionPacketId = params.id;

  const calibrationViewIdParam = new URLSearchParams(useLocation().search).get(
    'calibrationViewId'
  );
  const calibrationViewId = calibrationViewIdParam
    ? Number(calibrationViewIdParam)
    : undefined;

  return (
    <PromotionPacketProvider>
      <PromotionPacket
        promotionPacketId={promotionPacketId}
        calibrationViewId={calibrationViewId}
        inModal={false}
      />
    </PromotionPacketProvider>
  );
};

export default React.memo(PromotionPacketPage);
